/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Thresholds_MaleInputs */

const en_ui_thresholds_male = /** @type {(inputs: Ui_Thresholds_MaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Male`)
};

const de_ui_thresholds_male = /** @type {(inputs: Ui_Thresholds_MaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Männlich`)
};

/**
* | output |
* | --- |
* | "Male" |
*
* @param {Ui_Thresholds_MaleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_thresholds_male = /** @type {((inputs?: Ui_Thresholds_MaleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Thresholds_MaleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_thresholds_male(inputs)
	return de_ui_thresholds_male(inputs)
});